import { FnsDateSingleton } from '../infra/fnsDateAdapter';
import React, { createContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  children: React.ReactNode
}

type ContextType = {
    fnsDate: FnsDateSingleton
    convertToUTC: (value: string) => string
    utcStringToYearMonthDay: (value: string) => string
    formatDateWithOffset: (value: string) => string
    formatDateToString: (value: Date) => string
    formatMonthToString(value: string): string
    formatMonthDayDate(value: string): string
    formatFeedbackDate(value: string): { date: string; time: string };
}

export const FnsDateStateContext = createContext<ContextType | null >(null);

const FnsDateProvider = ({ children }: Props) => {
  const { i18n } = useTranslation();
  const fnsDate = new FnsDateSingleton(i18n.language);
  const [contextValue, setContextValue] = useState<ContextType>({
    fnsDate: fnsDate,
    convertToUTC: fnsDate.convertToUTC,
    formatDateToString: fnsDate.formatDateToString,
    formatDateWithOffset: fnsDate.formatDateWithOffset,
    utcStringToYearMonthDay: fnsDate.utcStringToYearMonthDay,
    formatMonthToString: fnsDate.formatMonthToString,
    formatMonthDayDate: fnsDate.formatMonthDayDate,
    formatFeedbackDate: fnsDate.formatFeedbackDate,
  });
  
  useEffect(() => {
    setContextValue({
      fnsDate: new FnsDateSingleton(i18n.language),
      convertToUTC: fnsDate.convertToUTC,
      formatDateToString: fnsDate.formatDateToString,
      formatDateWithOffset: fnsDate.formatDateWithOffset,
      utcStringToYearMonthDay: fnsDate.utcStringToYearMonthDay,
      formatMonthToString: fnsDate.formatMonthToString,
      formatMonthDayDate: fnsDate.formatMonthDayDate,
      formatFeedbackDate: fnsDate.formatFeedbackDate,
    });
  }, [i18n.language]);

  return <FnsDateStateContext.Provider value={contextValue}>{children}</FnsDateStateContext.Provider>;
};

export { FnsDateProvider }
